import React from "react"

import { TextField } from "@/components/form"
import i18n from "@/i18n"

export interface BasicInfoFormValues {
  venueName: string
  venueLogo: File | null
}

const BasicInfo: React.FC = () => {
  return (
    <>
      <div className="bg-white rounded-lg p-6 flex flex-col gap-6" data-testid="settings-venue-basic-info-container">
        <div>
          <TextField
            name="venueName"
            label={i18n.t("app.settings.venues.tabbio.basic_info.venue_name")}
            required
            data-testid="settings-venue-basic-info-input-name"
          />
        </div>
      </div>
    </>
  )
}

export default BasicInfo
